import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { AppstyleService } from 'src/core/appstyle/appstyle.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  titleApp = 'pet24App';
  backgroundColor: string;
  description: "Pet24 es una empresa digital pensada para mejorar la vida de las mascotas y sus tutores, localizamos la clínica más cercana en caso de accidente, las 24 horas. Agendamos citas en centros veterinarios y estéticos, generamos promociones y descuentos. En general, ponemos al sector veterinario al servicio de tu mascota.";


  constructor(
    private _styleService: AppstyleService,
    private meta: Meta,
    private title: Title,
    private swUpdate: SwUpdate
  ) {
    this.getBackGroundColor();
    this.title.setTitle(this.titleApp);
    this.meta.updateTag(
      {
        name: 'description',
        content: this.description
      });
    
    // Forzar actualización del Service Worker cuando hay nueva versión
    this.checkForSwUpdate();
  }

  /**
   * Verifica si hay una nueva versión del Service Worker disponible
   * y la activa automáticamente, recargando la página
   */
  private checkForSwUpdate(): void {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate().then(updateAvailable => {
        if (updateAvailable) {
          console.log('Nueva versión del SW disponible, actualizando...');
          this.swUpdate.activateUpdate().then(() => {
            document.location.reload();
          });
        }
      }).catch(err => {
        console.log('Error al verificar actualización del SW:', err);
      });
    }
  }

  getBackGroundColor() {
    this._styleService.backgroudcolor$.subscribe({
      next: (color: string) => {
        this.backgroundColor = color;
      }
    });
  }
}
